/**
 * @param {function} fn
 * @returns {function}
 */
function filter(fn) {
  return function (combine) {
    return function (result, x) {
      return fn(x) ? combine(result, x) : result;
    };
  };
}

export default filter;